import { CapturedPayment } from '../../Dashboard.types';
import { NewOrderSummary } from '../NewOrderSummary/NewOrderSummary';

export const ScheduledView = ({ plan }: { plan: CapturedPayment }) => {
  return (
    <div data-testid="approved-view">
      <div className="px-l py-m text-m font-reg text-structure-20">
        Your payment schedule has not yet started and will start 30 days after{' '}
        {plan.payLink.seller_trading_name} have confirmed the order.
      </div>
      <div className="px-l py-m">
        <NewOrderSummary title="Your pending payment schedule" plan={plan} />
      </div>
    </div>
  );
};
